const HideOnscrollWrapper = ({
    children = null,
    desktopOnly = false,
    className = '',
}: {
    children: React.ReactNode;
    desktopOnly?: boolean;
    className?: string;
}) => {
    const classes =
        '-:grid -:visible -:origin-top -:duration-layout -:grid-rows-[1fr] -:opacity-1';
    const mobileClasses =
        '-:transition-[grid-template-rows,_opacity,_visibility] -:group-[.slimHeader]:grid-rows-[0fr] -:group-[.slimHeader]:opacity-0 -:group-[.slimHeader]:invisible';
    const desktopClasses =
        '-:lg:transition-[grid-template-rows,_opacity,_visibility] -:lg:group-[.slimHeader]:grid-rows-[0fr] -:lg:group-[.slimHeader]:opacity-0 -:lg:group-[.slimHeader]:invisible';
    return (
        <div
            className={`${classes} ${
                desktopOnly ? desktopClasses : mobileClasses
            } ${className}`}
        >
            <div className="overflow-hidden">{children}</div>
        </div>
    );
};

export default HideOnscrollWrapper;
